export enum EAnticipationStatus {
  LIBERADO = 'liberado',
  BLOQUEADO = 'bloqueado',
  ALERTA = 'alerta',
}

export enum EMinorStatus {
  NOT_VERIFIED = 'not_verified',
  MINOR = 'minor',
  OF_AGE = 'of_age',
}

export interface IEliteLevel {
  id: number;
  name: string;
  parameters: {
    badge_elite: string;
    img_url: string;
    hint: string;
    texto: string;
  };
}

export type Wallet = {
  id: number;
  title: string;
};

export interface AccountManager {
  id: number;
  name: string;
  phone: string;
  email: string;
  isPublicManager: boolean;
  photo: string;
}

export interface User {
  id: number;
  account_id?: string;
  name: string;
  business_name: string;
  account_manager_id: number;
  producer: boolean;
  affiliate: boolean;
  coproducer: boolean;
  general_term: boolean;
  negociate_invoice: boolean;
  email: string;
  intercom_key?: string;
  document: string;
  beta_customer: boolean;
  type: 'J' | 'F' | 'E';
  photo: string;
  eadCharging: boolean;
  eligible: boolean;
  newbie: boolean;
  is_support: boolean;
  support_id: number;
  account_currency: number;
  has_transfer: boolean;
  current_elite_level: IEliteLevel;
  has_chat_black: boolean;
  is_elite: boolean;
  is_clube_black: boolean;
  partial_refund: boolean;
  coupom_batch: boolean;
  acceptence_terms: boolean;
  crossborder: boolean;
  international_account: boolean;
  subscription_physical: boolean;
  invoice_transfer: boolean;
  has_launch_export: boolean;
  not_recovering: number;
  new_anticipation_transfer: boolean;
  overdue_limit: boolean;
  termsAcceptance: boolean;
  full_name: string;
  show_previous_version_menu: boolean;
  anticipation_status: EAnticipationStatus;
  anticipation_status_message: string;
  create_new_account_bank: boolean;
  cell_phone: number;
  cannot_become_partner: boolean;
  qualification_key: string;
  show_account_owner_change_modal: boolean;
  wallet: Wallet | null;
  is_agency: boolean;
  live_helper_token?: string;
  pending_terms?: {
    id: string;
    comment: string;
    type: string;
    description: string;
    is_active: boolean;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date | null;
  }[];
  account_manager?: AccountManager;
}
